<template>
<div>
  <v-layout>
    <New v-on:created="created($event)" />
    <router-link :to="{ name:'related-group'}" class="dropdown-item">
      <v-btn>
        Grupy relacyjne
      </v-btn>
    </router-link>
  </v-layout>
  <v-container fluid grid-list-md>
    <v-app id="inspire">
      <v-data-table :headers="headers" :items="relatedSchemas" class="elevation-10">
        <template v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.keys.map(key => key.name).join(", ") }}</td>
          <td>
            <router-link :to="{ name:'related-values', params: { schemaId : props.item.id }}" class="dropdown-item">
              <v-btn small icon>
                <v-icon small fab block color="green darken-2" style="color: #efefef">search</v-icon>
              </v-btn>
            </router-link>

            <NewValue :key="props.item.id +'N'" :schema="props.item">
              <v-btn small icon slot="activator">
                <v-icon small fab block color="blue darken-2" style="color: #efefef">add_circle</v-icon>
              </v-btn>
            </NewValue>
            <Edit :schema.sync="props.item">
              <v-btn slot="activator" small icon>
                <v-icon small fab block color="grey darken-1" style="color: #efefef">edit</v-icon>
              </v-btn>
            </Edit>
            <v-btn @click="deleteSchema(props.item.id)" small icon>
              <v-icon small fab block color="orange darken-3" style="color: #efefef">delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-app>
  </v-container>

</div>
</template>
<script>
import New from "./New"
import Edit from "./Edit"
import NewValue from "./value/NewValue"
import http from '@/plugins/http'

export default {
  components: {
    New,
    Edit,
    NewValue
  },
  data() {
    return {
      name: "",
      headers: [{
        text: 'ID',
        value: "id",
        width: "50px"
      },
        {
          text: this.$t('related.name'),
          value: 'name'
        },
        {
          text: this.$t('related.keys'),
          value: 'keys'
        },
        {
          text: this.$t('related.actions'),
        }
      ],
      relatedSchemas: []
    }
  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  created() {
    http.get("related/schema")
        .then(data => this.relatedSchemas = data.data)
        .catch(() => null)
  },
  methods: {
    created(schema) {
      this.relatedSchemas.push(schema)
    },
    deleteSchema(id) {
      this.$confirm(this.$t('related.delete_confirmation'))
        .then(res => {
          if (res) {
            http.delete("related/schema/" + id).then(() => {
              this.relatedSchemas = this.relatedSchemas.filter(el => el.id != id)
            })
          }
        })
    }
  },
}
</script>

<style>

</style>
